import PropTypes from 'prop-types'

/** "Sort by" for the mobile filter drawers: the same columns as the desktop headers. */
export const MobileSortControl = ({ options, sort, onChange }) => {
  const handleKey = (e) => {
    const key = e.target.value
    onChange(key ? { key, dir: sort?.dir || 'asc' } : null)
  }

  return (
    <div className='space-y-2'>
      <label htmlFor='mobile-sort-by' className='block text-[13px] font-semibold text-[#0A1628]'>
        Sort by
      </label>
      <div className='flex gap-2'>
        <select
          id='mobile-sort-by'
          value={sort?.key || ''}
          onChange={handleKey}
          className='flex-1 rounded-lg border border-[#D1D5D8] bg-white px-3 py-2.5 text-[14px] text-[#0A1628]'
        >
          <option value=''>Default (newest first)</option>
          {options.map((o) => (
            <option key={o.value} value={o.value}>
              {o.label}
            </option>
          ))}
        </select>
        <div className='inline-flex overflow-hidden rounded-lg border border-[#D1D5D8]' role='group' aria-label='Sort direction'>
          {['asc', 'desc'].map((dir) => (
            <button
              key={dir}
              type='button'
              disabled={!sort}
              aria-pressed={sort?.dir === dir}
              onClick={() => onChange({ key: sort.key, dir })}
              className={`px-3 text-[13px] font-semibold disabled:opacity-40 ${
                sort?.dir === dir ? 'bg-sidebar text-white' : 'bg-white text-[#475569]'
              }`}
            >
              {dir === 'asc' ? 'Asc' : 'Desc'}
            </button>
          ))}
        </div>
      </div>
    </div>
  )
}

MobileSortControl.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({ value: PropTypes.string.isRequired, label: PropTypes.string.isRequired })).isRequired,
  sort: PropTypes.shape({ key: PropTypes.string, dir: PropTypes.oneOf(['asc', 'desc']) }),
  onChange: PropTypes.func.isRequired
}
